// Waits for the next microtask
// Useful for when waiting for Stimulus controllers to have connected
// https://jakearchibald.com/2015/tasks-microtasks-queues-and-schedules/

export default function microWait(func) {
  Promise.resolve().then(func)
}
